import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { donorapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});

export const fetchDatasearchSuccess = (dataview: any) => ({
    type: 'FETCH_DATA_SEARCH_SUCCESS',
    payload: dataview,
});


export const fetchDatasearch2Success = (dataview2: any) => ({
    type: 'FETCH_DATA_SEARCH2_SUCCESS',
    payload: dataview2,
});

export const fetchData3Success = (dataview3: any) => ({
    type: 'FETCH_DATA_SEARCH3_SUCCESS',
    payload: dataview3,
});
//To get list of officers data
export const fetchData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid}
            const apiname = donorapi.country;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const orgneeds = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid}
            const apiname = donorapi.orgs;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData3Success(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
//Search data
export const fetchDatasearch = (uid:any,needId:any,orgname:any,location:any,needstype:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid,needtype:needId,name:orgname,location:location,type:needstype}
            const apiname = donorapi.search;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDatasearchSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
//Organization
export const fetchDatasearch2 = (uid:any,catIds:any,firstnames:any,locations:any,org:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid,needtype:catIds,name:firstnames,location:locations,type:org}
            const apiname = donorapi.search;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDatasearch2Success(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
